<div class="app">
  <gpei-spinner></gpei-spinner>
  <gpei-alert-stack></gpei-alert-stack>
  <gpei-toast-stack></gpei-toast-stack>
  <router-outlet></router-outlet>
</div>
